import { render, staticRenderFns } from "./pane-info.vue?vue&type=template&id=5684034f&"
import script from "./pane-info.vue?vue&type=script&lang=js&"
export * from "./pane-info.vue?vue&type=script&lang=js&"
import style0 from "./pane-info.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports